import { UTSLocale } from "@smile2impress/attraction-constants";

import { getAppMode } from "utils/getAppMode";

export const TypeformIdsA = {
    [UTSLocale.FRANCE_FR]: "uzbZ5qEq",
    [UTSLocale.GB_EN]: "x8lUltCc",
    [UTSLocale.GERMANY_DE]: "US2zs1om",
    [UTSLocale.ITALY_IT]: "yIiHbk9p",
    [UTSLocale.NL_NL]: "X3WbAJWo",
    [UTSLocale.PORTUGAL_PT]: "nV8pTDLv",
    [UTSLocale.SPAIN_ES]: "lKpwrOAU",
    [UTSLocale.SWEDEN_SE]: "TtmNzsms",
    [UTSLocale.UKRAINE_UK]: "KtACoNEz",
    [UTSLocale.US_EN]: "uh1wAWKG",
    [UTSLocale.DENMARK_DK]: "", // Uses TypeformCPH, not experiment
};

export const TypeformIdsB = {
    ...TypeformIdsA,
    [UTSLocale.FRANCE_FR]: "NPeLRmGu",
    [UTSLocale.GB_EN]: "u52IC06N",
    [UTSLocale.GERMANY_DE]: "iDFlmOzm",
    [UTSLocale.ITALY_IT]: "toBoLgoy",
    [UTSLocale.NL_NL]: "rWYgCMpH",
    [UTSLocale.PORTUGAL_PT]: "V06MVMgp",
    [UTSLocale.SPAIN_ES]: "KRFmkTcc",
    [UTSLocale.SWEDEN_SE]: "Nqnjd4fu",
    [UTSLocale.UKRAINE_UK]: "S7wxRBa5",
    [UTSLocale.US_EN]: "ywqaGrmL",
    [UTSLocale.DENMARK_DK]: "", // Uses TypeformCPH, not experiment
};

export const TypeformComplainFormular = {
    [UTSLocale.NL_NL]: "NKjzgm5f",
};

export const TypeformSmajlaSweden = {
    [UTSLocale.SWEDEN_SE]: "TtmNzsms",
};

export const TypeformInvisalign = {
    [UTSLocale.GB_EN]: "pz9opRee",
};

export const TypeformCPH = {
    [UTSLocale.SWEDEN_SE]: "u67jHXEf",
    [UTSLocale.DENMARK_DK]: "XGOXLlwb",
};

export const TypeformSmileVision = {
    [UTSLocale.SPAIN_ES]: "XnvfSOnA",
};

const emptyPartialLeadIds: Record<UTSLocale, string> = {
    [UTSLocale.SPAIN_ES]: "",
    [UTSLocale.FRANCE_FR]: "",
    [UTSLocale.GB_EN]: "",
    [UTSLocale.GERMANY_DE]: "",
    [UTSLocale.ITALY_IT]: "",
    [UTSLocale.NL_NL]: "",
    [UTSLocale.PORTUGAL_PT]: "",
    [UTSLocale.SWEDEN_SE]: "",
    [UTSLocale.UKRAINE_UK]: "",
    [UTSLocale.US_EN]: "",
    [UTSLocale.DENMARK_DK]: "",
};

/** PSP partial-lead forms on live (closed route /candidate-partial-lead). */
export const TypeformPartialLeadIds = {
    ...emptyPartialLeadIds,
    [UTSLocale.SPAIN_ES]: "aWiiBMc3",
};

/**
 * Shared PSP copy for dev + prelive. No fallback to live — empty locale
 * means the closed route has no form on that stand.
 */
export const TypeformPartialLeadIdsNonLive = {
    ...emptyPartialLeadIds,
    [UTSLocale.SPAIN_ES]: "S11q5M2p",
};

export const getTypeformPartialLeadIds = (): Record<UTSLocale, string> => {
    const { isLiveMode } = getAppMode();
    return isLiveMode ? TypeformPartialLeadIds : TypeformPartialLeadIdsNonLive;
};
